// extracted by mini-css-extract-plugin
export default {"container":"ZKZOXp_xVoNVYCCoPO4s","logo":"Cxi6OOq_J007CCIcLDhG","smallLogo":"SSq9Ct7Bm1AP27qHbsEc"};